'use client';

import { NewsletterForm, type NewsletterFormTranslations } from './NewsletterForm';

export interface NewsletterSectionsProps {
  title?: string;
  translations: NewsletterFormTranslations;
  privacyPolicyUrl?: string;
  apiEndpoint?: string;
  className?: string;
  locale?: string;
}

export function NewsletterSections({
  title,
  translations,
  privacyPolicyUrl = '/legal/politika-konfidentsialnosti',
  apiEndpoint = '/api/newsletter',
  className = '',
  locale,
}: NewsletterSectionsProps) {
  const displayTitle = title || translations.title || '';

  return (
    <div className={`bg-white py-8 sm:py-16 dark:bg-gray-900 ${className}`}>
      <div className="">
        <div className="relative isolate flex flex-col gap-10 overflow-hidden bg-gray-900 px-6 py-24 shadow-2xl sm:rounded-3xl sm:px-24 xl:flex-row xl:items-center xl:py-32 dark:bg-gray-800 dark:shadow-none dark:after:pointer-events-none dark:after:absolute dark:after:inset-0 dark:after:inset-ring dark:after:inset-ring-white/15 dark:after:sm:rounded-3xl">
          {displayTitle && (
            <h2 className="max-w-xl text-3xl font-semibold tracking-tight text-balance text-white sm:text-4xl xl:flex-auto">
              {displayTitle}
            </h2>
          )}
          <NewsletterForm
            translations={translations}
            privacyPolicyUrl={privacyPolicyUrl}
            apiEndpoint={apiEndpoint}
            locale={locale}
          />
          <svg
            viewBox="0 0 1024 1024"
            aria-hidden="true"
            className="absolute top-1/2 left-1/2 -z-10 size-256 -translate-x-1/2"
          >
            <circle
              r={512}
              cx={512}
              cy={512}
              fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
              fillOpacity="0.7"
            />
            <defs>
              <radialGradient
                r={1}
                cx={0}
                cy={0}
                id="759c1415-0410-454c-8f7c-9a820de03641"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(512 512) rotate(90) scale(512)"
              >
                <stop stopColor="#7775D6" />
                <stop offset={1} stopColor="#E935C1" stopOpacity={0} />
              </radialGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}
